import type { AxiosPromise } from 'axios';
import BaseClient, { type ExtendedAxiosRequestConfig } from './BaseClient';
import type { CursorPaginationResponse } from './api';
import type {
    KioskTeamGroup,
    KioskTeamGroupSectionsParams,
    KioskTeamGroupSectionsResponse,
    KioskTeamGroupsCountParams,
    KioskTeamGroupsParams,
} from './adminTeamGroupsClient.types';

class AdminTeamGroupsClient extends BaseClient {
    getGroups(
        teamId: number,
        params?: KioskTeamGroupsParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<KioskTeamGroup>> {
        const url = `/api/admin/teams/${teamId}/groups/list`;
        return this.makeCoreApiRequest(url, 'post', params, null, config);
    }

    getGroupsCount(
        teamId: number,
        params?: KioskTeamGroupsCountParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<{ count: number }> {
        const url = `/api/admin/teams/${teamId}/groups/count`;
        return this.makeCoreApiRequest(url, 'post', params, null, config);
    }

    getGroupSections(
        teamId: number,
        params: KioskTeamGroupSectionsParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<KioskTeamGroupSectionsResponse> {
        const url = `/api/admin/teams/${teamId}/groups/sections`;
        return this.makeCoreApiRequest(url, 'post', params, null, config);
    }

    getGroupCustomAttributeKeys(teamId: number): AxiosPromise<{ data: string[]; truncated: boolean }> {
        const url = `/api/admin/teams/${teamId}/groups/custom-attribute-keys`;
        return this.makeCoreApiRequest(url, 'get');
    }
}

export default new AdminTeamGroupsClient();
